module.exports = __webpack_public_path__ + "static/media/Bubble-image-7.fa385f3d.png";